import { LIST_REMOVE_TEMPLATE } from 'src/redux/actions';
import { dispatch } from 'src/redux/store';
import type { NextWhere } from 'src/redux/types';

export const remove = (uuid: string, where: NextWhere, ignoreOp = false) => {
  if (uuid === where.parentId || !where.parentId) return;
  dispatch(LIST_REMOVE_TEMPLATE({ parentId: where.parentId, uuid, ignoreOp }));
};
